import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Link } from 'react-router-dom'
import { brandColors, brandFonts } from '../../styled/brand'
import { Wrap } from './Wrap'
import LogoMark from './LogoMark'

/**
 * Shared near-black footer rendered on every page (Home included). Single row
 * on desktop — logo left, legal links center, copyright right — stacking to a
 * centered column below 900px. Links point at the existing legal routes.
 */
const legalLinks = [
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/eula', label: 'EULA' },
]

const FooterInner = styled(Wrap)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 32,
  paddingTop: 48,
  paddingBottom: 48,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    textAlign: 'center',
  },
}))

const FooterLink = styled(Link)({
  fontFamily: brandFonts.body,
  fontWeight: 500,
  fontSize: 15,
  color: brandColors.footerText,
  textDecoration: 'none',
  '&:hover': { color: brandColors.creamLight },
})

const SiteFooter = () => (
  <Box
    component="footer"
    sx={{
      background: brandColors.nearBlack,
      borderTop: '1px solid rgba(255,255,255,0.08)',
    }}
  >
    <FooterInner>
      <Box component={Link} to="/" sx={{ textDecoration: 'none', color: brandColors.cream }}>
        <LogoMark iconSize={24} fontSize={17} />
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '28px' }}>
        {legalLinks.map((l) => (
          <FooterLink key={l.to} to={l.to}>
            {l.label}
          </FooterLink>
        ))}
      </Box>
      <Box sx={{ fontSize: 14, color: brandColors.footerMuted }}>
        © {new Date().getFullYear()} Apperytime. All rights reserved.
      </Box>
    </FooterInner>
  </Box>
)

export default SiteFooter
